module["exports"] = [
  "Inc",
  "and Sons",
  "LLC",
  "Group"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/company/suffix.js
 ** module id = 927
 ** module chunks = 0
 **/